export let SITEID = "1"; // Sửa site ở site của user login;
export let SITENAME = "Genba 4" // Sửa site ở site của user login;
export const PAGESIZE = 10;